/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from "react"

import { STATUS_METADATA_DISPATCHER } from "./statusMetadataDispatcher"
import { UNKNOWN_STATUS } from "../../../constants/generalConstants"
import AppChip from "../../dataDisplay/chips/appChip"
import AppTooltip from "../../helper/appTooltip"

interface StatusChipProps {
    status: string
    sx?: Record<string, string | number>
    customTooltip?: string
}

/**
 * Returns chip / pill for generic application statuses. Status must be defined
 * in `./statusChipDispatcher.ts`. The configs in this dispatcher are
 * referenced via the status keyword.

 * @example
 * <StatusChip status="Compliant" />
 */
const StatusChip = ({
    status,
    sx,
    customTooltip,
}: StatusChipProps): ReactElement => {
    const unknownConfig = STATUS_METADATA_DISPATCHER[UNKNOWN_STATUS]
    const statusConfig = STATUS_METADATA_DISPATCHER[status] || unknownConfig
    const tooltip = customTooltip || statusConfig.tooltip

    return (
        <AppTooltip title={tooltip}>
            <span>
                <AppChip
                    color={statusConfig.color || unknownConfig.color}
                    icon={(props) =>
                        (
                            <statusConfig.icon
                                aria-label={statusConfig.iconAriaLabel}
                                {...props}
                            />
                        ) || (
                            <unknownConfig.icon
                                aria-label={unknownConfig.iconAriaLabel}
                                {...props}
                            />
                        )
                    }
                    variant="filled"
                    label={statusConfig.label || status}
                    sx={{ ...sx }}
                />
            </span>
        </AppTooltip>
    )
}

StatusChip.defaultProps = {
    sx: null,
    customTooltip: "",
}

export default StatusChip
